
import { Component, Prop, Vue } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import api from '@/api';
import { Route } from 'vue-router';
import swal from 'sweetalert2';

const { member } = api;
const genders = ['女', '男', '其他'];
const dataAudiFlows = ['未送審', '待審核', '審核通過', '審查未通過'];

@Component({ components: { Dialog } })
export default class UserAuth extends Vue {
  @Prop({ required: true }) private userId!: string;

  private loading = false;

  private data = {
    authStatus: 1,
    dataAudiFlow: 0,
    inviter: null,
    inviterPId: null,
    gender: null,
    roles: [],
  };

  private messages = [
    '所輸入之出生年月日與證件不相符',
    '請使用身分證正本拍攝上傳',
    '身分證請完整露出拍攝，請勿裁切重要資訊',
    '身分證號與證件不相符',
    '所輸入之姓名與證件不相符',
    '請拍攝身分證正本，勿使用翻拍照片上傳',
    '身分證件拍攝模糊，請重新拍攝上傳',
    '其他',
  ];

  private isShowAuthFailMessageDiaglog = false;

  private failMessage = this.messages[0];

  private failMessageOther = '';

  private prevPath = '';

  private get isShowApprovalButtons() {
    return this.data.authStatus === 1 && this.data.dataAudiFlow === 1;
  }

  private get isCompany() {
    return this.data.roles.some((role) => role === 2);
  }

  private get namePrefix() {
    return this.isCompany ? '負責人' : '';
  }

  private get gender() {
    const { gender } = this.data;
    return Number.isInteger(gender) ? genders[gender ?? 0] : '';
  }

  private get audiFlow() {
    return dataAudiFlows[this.data.dataAudiFlow];
  }

  private requiredRule(column: string) {
    return (v: any) => !!v || `${column} 為必填`;
  }

  private isMP4(url: string): boolean {
    return !!url && !!url.split('.').pop()?.match(/^mp4/gi);
  }

  private async cancel() {
    await this.$router.back();
  }

  private async auth(isApprove: boolean, authFailReason: string) {
    const form = this.$refs.failRequestForm as any;
    if (isApprove === false && form.validate() === false) {
      return;
    }
    this.loading = true;
    const { status } = await member.auth(this.userId, {
      isApprove,
      authFailReason,
    });

    this.loading = false;

    if (status === 1) {
      await swal.fire({
        icon: 'info',
        title: '操作完成',
      });
      await this.$router.push(this.prevPath || { name: 'member-auth-list' });
    }
  }

  setPrevPath(prevPath: string) {
    this.prevPath = prevPath;
  }

  private async requestData() {
    const { data } = await member.get(this.userId);
    this.data = data;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: UserAuth) => void) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
      vm.setPrevPath(from.fullPath);
    });
  }
}
